/* eslint no-inline-comments: 0 */

const List = () => import( /* webpackChunkName: "group-network-rules" */ `./list.vue` );

export default {
	path: `network-rules`,
	children: [
		{
			path: ``,
			name: `list-network-rules`,
			component: List,
			meta: {
				title: `Network Rules`
			}
		}
	]
};
